module.exports = __webpack_public_path__ + "img/2-normal-de-ne-pas-tout-connaître.a1540aa7.png";